import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a903433e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=a903433e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a903433e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a903433e')) {
      api.createRecord('a903433e', component.options)
    } else {
      api.reload('a903433e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=a903433e&scoped=true&", function () {
      api.rerender('a903433e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/exerciseRightSetting/detail.vue"
export default component.exports